import { useEffect, useState } from 'react';
import { shippingAPI, authAPI } from './api';
import { i18n } from './i18n';

const KEY = 'shippingSummary';
const COUNTRY_KEY = 'shipCountry';
const EVENT = 'shipping-summary';
const LANG_COUNTRY = { fr: 'FR', en: 'FR', de: 'DE', es: 'ES', it: 'IT' };
export const COUNTRY_CODES = { france: 'FR', belgique: 'BE', belgium: 'BE', allemagne: 'DE', deutschland: 'DE', germany: 'DE', italie: 'IT', italia: 'IT', italy: 'IT', espagne: 'ES', españa: 'ES', spain: 'ES', 'pays-bas': 'NL', nederland: 'NL', netherlands: 'NL', luxembourg: 'LU', portugal: 'PT', autriche: 'AT', österreich: 'AT', austria: 'AT', suisse: 'CH', schweiz: 'CH', irlande: 'IE', pologne: 'PL' };

let cache = (() => { try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch { return {}; } })();
const pending = {};

const accountCountry = () => { try { return JSON.parse(localStorage.getItem('user') || 'null')?.ship_country || null; } catch { return null; } };

// Customer's delivery country (2-letter code): explicit choice → country saved in the account → UI language → FR
export const customerCountry = {
  get: () => localStorage.getItem(COUNTRY_KEY) || accountCountry() || LANG_COUNTRY[i18n.get()] || 'FR',
  set: (value) => {
    const v = (value || '').trim();
    const code = v.length === 2 ? v.toUpperCase() : COUNTRY_CODES[v.toLowerCase()];
    if (!code || code === localStorage.getItem(COUNTRY_KEY)) return;
    localStorage.setItem(COUNTRY_KEY, code);
    window.dispatchEvent(new Event(EVENT));
    shippingInfo.load(code);
    if (authAPI.isAuthenticated()) {
      authAPI.setShipCountry(code).then(() => {
        try { const u = JSON.parse(localStorage.getItem('user') || 'null'); if (u) localStorage.setItem('user', JSON.stringify({ ...u, ship_country: code })); } catch { /* ignore */ }
      }).catch(() => {});
    }
  },
};

// Free-shipping threshold / base price per country, driven by the admin shipping settings
export const shippingInfo = {
  get: (country = customerCountry.get()) => cache[country] || null,
  load: (country = customerCountry.get(), force = false) => {
    if (cache[country] && !force) return Promise.resolve(cache[country]);
    if (!pending[country]) {
      pending[country] = shippingAPI.summary(country).then(s => {
        cache[country] = { country: s.country, countryName: s.country_name, served: s.served, freeFrom: s.free_from, price: s.price };
        sessionStorage.setItem(KEY, JSON.stringify(cache));
        window.dispatchEvent(new Event(EVENT));
        return cache[country];
      }).catch(() => cache[country]).finally(() => { delete pending[country]; });
    }
    return pending[country];
  },
  refresh: () => { cache = {}; sessionStorage.removeItem(KEY); return shippingInfo.load(customerCountry.get(), true); },
};

export const useShippingSummary = () => {
  const [, tick] = useState(0);
  useEffect(() => {
    const h = () => { tick(x => x + 1); shippingInfo.load(); };
    window.addEventListener(EVENT, h);
    window.addEventListener('lang-changed', h);
    shippingInfo.load();
    return () => { window.removeEventListener(EVENT, h); window.removeEventListener('lang-changed', h); };
  }, []);
  const country = customerCountry.get();
  return cache[country] || { country, countryName: null, served: true, freeFrom: null, price: null };
};

export const fmtEuro = (v) => `${Number(v).toFixed(2).replace(/\.00$/, '').replace('.', ',')} €`;
